<template>
  <div class="commonLiStyle">
    <top-component></top-component>
    <div class="titlePu">
      <div>专业联合体</div>
    </div>
    <div class="commonLiContainer">
      <div class="Comcontainer">
        <div class="TopConOne">
          <div class="zhuanye">
            <div class="title">专业联合体</div>
            <div class="zhuanyeDiv" v-for="(item, index) in dataTable" :key="index" @click="ZhuanYeClick(item)">
              &emsp;{{item.publisherType}}</div>
          </div>
          <!-- <div class="zhuanye-gg" @click="ActiveClick">
            <img src="../../assets/images/schoolPng.jpg" alt="">
          </div> -->
        </div>
      </div>
    </div>
    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import BottomComponent from '../Components/BottomComponent.vue'
  import TopComponent from '../Components/TopComponent.vue'
  import { listclassifyTypes, searchlist } from '@/api/img'
  import { selectUnionPublisher } from '@/api/pages'
  import Cookies from 'js-cookie'
  export default {
    name: 'SchoolLibrary',
    data() {
      return {
        dataTable: [],
        xuekeFenlei: [],
        ChinesData: [],
      }
    },
    mounted() {
      this.LianheData()
    },
    methods: {
      // 联合体
      LianheData() {
        selectUnionPublisher().then(response => {
        //   console.log(response)
          this.dataTable = response.data
        })
      },
      // 点击联合体
      ZhuanYeClick(item) {
        // console.log(item)
        this.$router.push({ name: 'PublisherChildsCoalition', params: { areaName: item.publisherType } })
      }
    },
    components: {
      BottomComponent,
      TopComponent
    },
  }
</script>

<style scoped lang="scss">
  .commonLiStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  /* banner */
  .titlePu {
    height: 90px;
    width: 100%;
    background-image: url('../../assets/images/TopChild.png');
  }

  .titlePu>div {
    width: 1200px;
    height: 100%;
    margin: 0px auto;
    display: flex;
    align-items: center;
    color: rgba(51, 51, 51, 1);
    font-size: 24px;
    text-align: left;
    font-weight: 500;
    font-family: PingFang-SC-Bold;
  }

  /* 公共 */
  .commonLiContainer {
    width: 1200px;
    margin-left: calc(50% - 600px);
  }

  .Comcontainer {
    width: 100%;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 0px;
  }

  .title {
    height: 50px;
    line-height: 50px;
    margin-left: 15px;
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    text-align: left;
    font-family: PingFang-SC-Bold;
  }

  /* 1 */
  .TopConOne {
    width: 100%;
    font-size: 0px;
  }

  /* 1、1 */
  .zhuanye {
    width: calc(80% - 20px);
    padding: 3px 0px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    display: inline-block;
  }

  .zhuanyeDiv {
    padding: 5px 20px;
    left: 385px;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
    display: inline-block;
    cursor: pointer;
  }

  /* 1、2 */
  .zhuanye-gg {
    width: 20%;
    height: 140px;
    margin-left: 18px;
    display: inline-block;
    font-size: 18px;
    vertical-align: top;
    text-align: center;
    line-height: 137px;
  }

  .zhuanye-gg>img {
    width: 100%;
    height: 100%;
    cursor: pointer;
  }

  /* 2 */
  .TopConTwo {
    width: 100%;
    margin-top: 20px;
    font-size: 0px;
  }

  /* 2、1 */
  .xueke {
    width: calc(80% - 20px);
    padding: 3px 0px;
    /* height: 731px; */
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    display: inline-block;
  }

  .xuekeDiv {
    width: 100%;
    border-bottom: 1px solid rgba(226, 226, 226, 1);
    padding: 15px 0px;
    position: relative;
  }

  .xuekeTitle {
    width: 100px;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFang-SC-Bold;
    display: inline-block;
    position: absolute;
    left: 15px;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
  }

  .xuekeContent {
    width: calc(100% - 120px);
    margin-left: 120px;
    height: 30px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
    display: inline-block;
  }

  .xuekeContent .spanOneItem {
    display: inline-block;
    /* width: 16.6%; */
    padding: 0px 20px;
    line-height: 30px;
  }

  .xuekeContent .spanTwoItem {
    width: 100%;
    background-color: rgba(249, 249, 249, 1);
    margin-top: 20px;
  }

  .childrenStyle {
    padding: 0px 20px;
    display: inline-block;
    line-height: 30px;
  }

  /* 2、2 */
  .xueke-gg {
    width: 20%;
    height: 731px;
    margin-left: 18px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
    display: inline-block;
    vertical-align: top;
  }

  .chinesDataStyle {
    padding: 5px 10px;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFangSC-Regular;
  }

  .chinesDataStyle:hover {
    color: #175199;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/ChildPages/Major-Consortium.vue